import { ExperimentVariants } from '@gumtree/shared/src/types/client-data';
import { getGrowthbookClientSide } from '@gumtree/shell/src/growthbook/init-growthbook';

type FeatureValueFormat = (value: boolean | string | undefined) => ExperimentVariants | '' | 'OFF';
export type AdExperimentKeyValue = [string, string];

// GrowthBookAdFeatures key exprimentId, value is feature. for exprimentId !== featureKey
export const GrowthBookAdFeatures = {
    bid03: 'bid03',
    bid04: 'bid04',
    'pre-ad-source': 'pre-ad-source',
    bid02: 'bid02',
    'prebid-timeout': 'prebid-timeout',
    'nearby-listing-new-ads': 'nearby-listing-new-ads',
    'consent-banner-new-design': 'consent-banner-new-design',
    'adsense-query': 'adsense-query',
    GAM02: 'GAM02',
    ad01: 'ad01',
    ad03: 'ad03',
    ad04: 'ad04',
    ad02_2s: 'ad02_2s',
    'CLP-M': 'CLP-M',
    value_banner: 'value_banner',
    'vip-m': 'VIP-M',
    'RH-PC1': 'RH-PC1',
    'RH-PC2': 'RH-PC2',
};

const CMP_REPROMPT_KEY = 'cmp_reprompt';
const VALID_CMP_REPROMPT_VALUES = [
    'A_decline',
    'A_accept',
    'B_decline',
    'B_accept',
    'C_decline',
    'C_accept',
];

export const getCmpRepromptValue = (): string | null => {
    try {
        const value = globalThis.localStorage?.getItem(CMP_REPROMPT_KEY);
        if (value && VALID_CMP_REPROMPT_VALUES.includes(value)) {
            return value;
        }
    } catch {
        // localStorage not available
    }
    return null;
};

export const featuresToKeyValue = (
    features: Record<string, string>,
    format: FeatureValueFormat = (val) => val as ExperimentVariants
) => {
    const growthbookClient = getGrowthbookClientSide();
    if (!growthbookClient) return [];
    return Object.entries(features)
        .map(([exprimentId, feature]) => {
            const value = format(growthbookClient.getFeatureValue(feature, ''));
            if (value === '' || value === 'OFF') return null;
            return [exprimentId, value];
        })
        .filter(Boolean) as AdExperimentKeyValue[];
};
